<template>
  <div class="event-modal-passes-actions">
    <LinkIcon
      icon="download-grey"
      :grey="true"
      :bold="true"
      @click="$emit('download')"
    >
      {{ locale === "en" ? "Download all" : "Скачать все" }}
    </LinkIcon>
    <LinkIcon
      icon="print-grey"
      :grey="true"
      :bold="true"
      @click="$emit('print')"
    >
      {{ locale === "en" ? "Print all" : "Напечатать все" }}
    </LinkIcon>
  </div>
</template>

<script>
import { LinkIcon } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalPassesActions",

  components: {
    LinkIcon
  },

  computed: {
    locale() {
      return i18n.locale;
    }
  }
};
</script>

<style lang="scss" scoped>
.event-modal-passes-actions {
  padding: 10px 24px;
  width: 100%;
  max-width: 300px;
  box-sizing: border-box;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
